var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1295 3.63074C8.87965 2.88059 9.89707 2.45917 10.9579 2.45917C12.0188 2.45917 13.0362 2.88059 13.7864 3.63074C14.5365 4.38089 14.9579 5.3983 14.9579 6.45917V9.45917H6.95793V6.45917C6.95793 5.3983 7.37936 4.38089 8.1295 3.63074ZM4.95793 9.45917V6.45917C4.95793 4.86787 5.59007 3.34175 6.71529 2.21653C7.84051 1.09131 9.36663 0.459167 10.9579 0.459167C12.5492 0.459167 14.0754 1.09131 15.2006 2.21653C16.3258 3.34175 16.9579 4.86787 16.9579 6.45917V9.45917H17.9579C19.6148 9.45917 20.9579 10.8023 20.9579 12.4592V19.4592C20.9579 21.116 19.6148 22.4592 17.9579 22.4592H3.95793C2.30108 22.4592 0.957932 21.116 0.957932 19.4592V12.4592C0.957932 10.8023 2.30108 9.45917 3.95793 9.45917H4.95793ZM15.9579 11.4592H5.95793H3.95793C3.40565 11.4592 2.95793 11.9069 2.95793 12.4592V19.4592C2.95793 20.0115 3.40565 20.4592 3.95793 20.4592H17.9579C18.5102 20.4592 18.9579 20.0115 18.9579 19.4592V12.4592C18.9579 11.9069 18.5102 11.4592 17.9579 11.4592H15.9579Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6ca3a332.svg";
export { ForwardRef as ReactComponent };